import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import store, { history } from './store';
import { ConnectedRouter } from 'connected-react-router';
import * as serviceWorker from './serviceWorker';
import 'overlayscrollbars/css/OverlayScrollbars.css';

import './index.css';
import 'rocket/assets/css/Base.css';
import './styles/scss/main.scss';

import * as amplitude from '@amplitude/analytics-browser';

// Amplitude v2: enable autocapture while keeping remote config disabled for now
amplitude.init(`${process.env.REACT_APP_AMPLITUDE_KEY}` as string, undefined, {
    autocapture: true,
    remoteConfig: { fetchRemoteConfig: false },
    minIdLength: 1 // Allow 4-digit backend ids; default minimum is 5 characters
} as unknown as any);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
